import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Styles from '../Style/Common.module.css';
import BtnStyle from '../Style/Button.module.css';
import { Link } from "react-router-dom";
import constants from '../../services/constants';
import parse from 'html-react-parser';  
//icon
import { RxArrowTopRight } from "react-icons/rx";

const TQjoinTeam = ({ data })=>{
   const joinData = data;
   console.log(joinData)
    return(
        <div className={'ourTeam ' + Styles.JoinTeamSec}>
            <Container>
                <Row>
                    <Col>
                        <div className={Styles.InnerContainer}>
                            <Row>
                                <Col md={7}>
                                    <div className={Styles.teamContent}>
                                        <h2 className={Styles.title}>{joinData?.title}</h2>
                                        <p className={Styles.subTitle}>{parse(joinData?.description)}</p>
                                        {/* <p>Let us shape a world of trust, while growing together. </p> */}
                                        <Link to={joinData?.link} className={BtnStyle.roundBtn + ' ' + BtnStyle.RoundRedWhite}>
                                            <RxArrowTopRight />
                                        </Link>
                                    </div>
                                </Col>
                                <Col md={5} className={Styles.gridContainer}>
                                    {joinData.image?.length > 0 && (
                                        <>
                                            {(() => {
                                            const images = joinData.image;
                                            const half = Math.ceil(images.length / 2);

                                            const firstHalf = images.slice(0, half);
                                            const secondHalf = images.slice(half);

                                            return (
                                                <>
                                                {/* First Half */}
                                                <div className={Styles.teamGrid}>
                                                    {firstHalf.map((item, index) => (
                                                    <div key={item._id || index}>
                                                        <figure>
                                                        {item.fileName && (
                                                            <img
                                                            src={`${constants.Image_BASE_URL}${item.fileName}`}
                                                            alt={joinData.title}
                                                            width="400"
                                                            height="560"
                                                            />
                                                        )}
                                                        </figure>
                                                    </div>
                                                    ))}
                                                </div>

                                                {/* Second Half */}
                                                <div className={Styles.teamGrid}>
                                                    {secondHalf.map((item, index) => (
                                                    <div key={item._id || index}>
                                                        <figure>
                                                        {item.fileName && (
                                                            <img
                                                            src={`${constants.Image_BASE_URL}${item.fileName}`}
                                                            alt={joinData.title}
                                                            width="400"
                                                            height="560"
                                                            />
                                                        )}
                                                        </figure>
                                                    </div>
                                                    ))}
                                                </div>
                                                </>
                                            );
                                            })()}
                                        </>
                                        )}
                                </Col>
                            </Row>
                        </div>
                    </Col>
                </Row>
            </Container>
            {/* <img src={require('../../assest/images/Mask.png')} className={Styles.maskImg} /> */}
            {/* <div className={Styles.blankDiv}></div> */}
        </div>
    )
}

export default TQjoinTeam;